module.exports = __webpack_public_path__ + "static/media/keyboard-listener.6340cb6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keyboard-listener.png
// module id = 25
// module chunks = 0